import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appInputMaxLength]'
})
export class InputMaxLengthDirective {
  @Input() appInputMaxLength: string = '120'; // Default to 120 characters
  @Input() appInputDecimalPlaces?: string | number;

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value;
    const decimalPlaces = Number(this.appInputDecimalPlaces);

    if (
      this.appInputDecimalPlaces !== undefined &&
      value.includes('.') &&
      Number.isInteger(decimalPlaces) &&
      decimalPlaces >= 0
    ) {
      const [whole, fraction] = value.split('.');
      value = `${whole}.${fraction.slice(0, decimalPlaces)}`;
    }

    if (value.length > +this.appInputMaxLength) {
      value = value.slice(0, +this.appInputMaxLength);
    }

    if (input.value !== value) {
      input.value = value;
      input.dispatchEvent(new Event("input"));
    }
  }
}
